import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tech-button',
  templateUrl: './tech.button.component.html',
  styleUrls: ['./tech.button.component.scss']
})
export class TechButtonComponent implements OnInit {

  public tech;
  public Game;
  public technologyService;
  public costs;
  public buildingRequirements;

  constructor() {
    this.costs = [];
  }

  @Input()
  set techData(tech: any) {
    this.tech = tech;
    this.costs = [];
    Object.entries(tech[1].costs).forEach((cost) => {
      this.costs.push({
        resource: cost[0],
        amount: cost[1],
      });
    });
    this.buildingRequirements = [];
    Object.entries(tech[1]. building_requirements).forEach((BR) => {
      this.buildingRequirements.push({
        resource: BR[0],
        amount: BR[1],
      });
    });
  }

  @Input()
  set game(game: any) {
    this.Game = game;
    this.technologyService = this.Game.technologyService;
  }

  ngOnInit() {
  }

  public research() {
    this.technologyService.research(this.tech[0]);
  }

}
